import React, { useMemo, useState } from "react";
import axiosInstance from "../config/axiosConfig";
import BuscarPaciente from "./components/BuscarPaciente";

const getPeriodoActual = () => {
    const fecha = new Date();
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
};

const periodoRango = (periodo) => {
    if (!periodo) return "";

    const [year, month] = periodo.split("-").map(Number);
    if (!year || !month) return "";

    const desde = new Date(year, month - 1, 26);
    const hasta = new Date(year, month, 25);
    const fmt = (fecha) => fecha.toLocaleDateString("es-CL", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });

    return `${fmt(desde)} al ${fmt(hasta)}`;
};

const CreacionManualTurnos = () => {
    const [paciente, setPaciente] = useState(null);
    const [periodo, setPeriodo] = useState(getPeriodoActual());
    const [resultado, setResultado] = useState(null);
    const [loading, setLoading] = useState(false);

    const rango = useMemo(() => periodoRango(periodo), [periodo]);

    const handleGenerar = async () => {
        if (!paciente?.id || !periodo) {
            setResultado({
                error: true,
                message: "Debe seleccionar paciente y periodo.",
            });
            return;
        }

        setLoading(true);
        setResultado(null);
        try {
            const { data } = await axiosInstance.post("/turnos/manual/generar", {
                pacienteID: paciente.id,
                periodo,
            });
            setResultado(data);
        } catch (error) {
            console.error(error);
            setResultado({
                error: true,
                message: "No se pudo generar la creacion manual de turnos.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                    <h4 className="mb-1">Creacion Manual de Turnos</h4>
                    <p className="text-muted mb-0">
                        Genera registros limpios del calendario para asignar turnos.
                    </p>
                </div>
            </div>

            <div className="card shadow-sm">
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-7">
                            <label className="form-label fw-semibold">Paciente</label>
                            <BuscarPaciente onSelect={setPaciente} retirados={1} />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label fw-semibold">Periodo</label>
                            <input
                                type="month"
                                className="form-control"
                                value={periodo}
                                onChange={(e) => setPeriodo(e.target.value)}
                            />
                            {rango && <small className="text-muted">Rango: {rango}</small>}
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                            <button
                                type="button"
                                className="btn btn-primary w-100"
                                disabled={loading}
                                onClick={handleGenerar}
                            >
                                {loading ? "Generando..." : "Generar"}
                            </button>
                        </div>
                    </div>

                    {paciente && (
                        <div className="alert alert-light border mt-4 mb-0">
                            <strong>Paciente seleccionado:</strong>{" "}
                            {paciente.nombres || paciente.nombrePaciente || paciente.label || paciente.nombre}{" "}
                            {paciente.apellidoPaterno || ""}
                        </div>
                    )}

                    {resultado && (
                        <div className={`alert mt-4 mb-0 ${resultado.error ? "alert-danger" : "alert-success"}`}>
                            <div className="fw-semibold">{resultado.message}</div>
                            {resultado.data && (
                                <div className="small mt-2">
                                    Periodo generado: {resultado.data.desde} al {resultado.data.hasta}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CreacionManualTurnos;
